import { initializeApp, getApp, getApps } from 'firebase/app';
import {
  OAuthProvider,
  FacebookAuthProvider,
  browserLocalPersistence,
  getAuth,
  GoogleAuthProvider,
  setPersistence,
} from 'firebase/auth';
import { firebaseConfig, firebaseEnabled } from '@/lib/firebase-config';

const app = firebaseEnabled ? (getApps().length ? getApp() : initializeApp(firebaseConfig)) : null;

export const firebaseApp = app;
export const firebaseAuth = app ? getAuth(app) : null;
export const firebaseGoogleProvider = app ? new GoogleAuthProvider() : null;
export const firebaseFacebookProvider = app ? new FacebookAuthProvider() : null;
export const firebaseAppleProvider = app ? new OAuthProvider('apple.com') : null;

firebaseGoogleProvider?.setCustomParameters({ prompt: 'select_account' });
firebaseFacebookProvider?.addScope('email');
firebaseAppleProvider?.addScope('email');
firebaseAppleProvider?.addScope('name');

if (firebaseAuth) {
  setPersistence(firebaseAuth, browserLocalPersistence).catch(() => {
    return undefined;
  });
}
